import { atom } from "recoil";

/**
 * WhatsApp-style floating internal chat panel (header envelope).
 */
export const internalChatPopupOpenAtom = atom<boolean>({
  key: "frontdesk.internalChatPopup.open",
  default: false,
});

/**
 * When true, the popup stays mounted but shows as a small bottom-corner bar.
 */
export const internalChatPopupMinimizedAtom = atom<boolean>({
  key: "frontdesk.internalChatPopup.minimized",
  default: false,
});

/**
 * When set, the popup opens (or switches) to this conversation thread.
 */
export const internalChatPopupConversationIdAtom = atom<string | null>({
  key: "frontdesk.internalChatPopup.conversationId",
  default: null,
});
